import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock, Save } from "lucide-react";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { PathologiesTab } from "@/components/patient/PathologiesTab";

const HABITS = [
  { key: "colazione", label: "Colazione" },
  { key: "spuntino_mattina", label: "Spuntino mattina" },
  { key: "pranzo", label: "Pranzo" },
  { key: "spuntino_pomeriggio", label: "Spuntino pomeriggio" },
  { key: "cena", label: "Cena" },
];

const HabitRow = ({ h, value, onChange }) => (
  <div className="grid gap-3 border-b border-[#e2e8f0] py-4 last:border-0 md:grid-cols-[150px_1fr_1fr]" data-testid={`habit-row-${h.key}`}>
    <div className="pt-2 text-sm font-bold text-[#3d655b]">{h.label}</div>
    <textarea className="field min-h-[72px]" value={value.text || ""} placeholder="Cosa mangia abitualmente…"
      onChange={(e) => onChange({ ...value, text: e.target.value })} data-testid={`habit-${h.key}-text`} />
    <textarea className="field min-h-[72px] bg-[#fbf8f4]" value={value.notes || ""} placeholder="Note (orari, quantità, preferenze…)"
      onChange={(e) => onChange({ ...value, notes: e.target.value })} data-testid={`habit-${h.key}-notes`} />
  </div>
);

export function AnamnesisTab({ rec, reload }) {
  const p = rec.patient;
  const [text, setText] = useState(p.anamnesis || "");
  const [habits, setHabits] = useState(p.eating_habits || {});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setText(p.anamnesis || ""); setHabits(p.eating_habits || {}); }, [p]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/patients/${p.id}/anamnesis`, { text, habits });
      toast.success("Anamnesi salvata");
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-8">
      <div className="card space-y-4" data-testid="anamnesis-card">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h3 className="text-lg font-bold">Anamnesi</h3>
            <p className="flex items-center gap-1 text-xs text-slate-500"><Lock className="h-3 w-3" /> Visibile solo alla dottoressa{p.anamnesis_updated_at ? ` · aggiornata ${fmtDateTime(p.anamnesis_updated_at)}` : ""}</p>
          </div>
          <button className="btn-primary" onClick={save} disabled={saving} data-testid="anamnesis-save-button"><Save className="h-4 w-4" /> {saving ? "Salvataggio…" : "Salva anamnesi"}</button>
        </div>
        <textarea className="field min-h-[160px]" value={text} onChange={(e) => setText(e.target.value)}
          placeholder="Abitudini, stile di vita, attività fisica, sonno, farmaci, storia familiare, intolleranze…" data-testid="anamnesis-text-input" />
        <div>
          <h4 className="mb-1 text-base font-bold">Abitudini alimentari</h4>
          <div className="hidden gap-3 md:grid md:grid-cols-[150px_1fr_1fr]"><span /><span className="label-xs">Pasto</span><span className="label-xs">Note</span></div>
          {HABITS.map((h) => (
            <HabitRow key={h.key} h={h} value={habits[h.key] || {}} onChange={(v) => setHabits({ ...habits, [h.key]: v })} />
          ))}
        </div>
        <div className="flex justify-end">
          <button className="btn-primary" onClick={save} disabled={saving} data-testid="anamnesis-save-button-bottom"><Save className="h-4 w-4" /> Salva anamnesi</button>
        </div>
      </div>
      <div>
        <h3 className="mb-4 text-lg font-bold">Patologie</h3>
        <PathologiesTab rec={rec} reload={reload} />
      </div>
    </div>
  );
}
